module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "fileUpload"
    },
    on: {
      "change": _vm.fileUploaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body row",
    staticStyle: {
      "min-height": "60vh"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "min-height": "40vh",
      "max-height": "70vh",
      "overflow": "scroll"
    }
  }, [_c('ul', {
    staticClass: "list-group",
    attrs: {
      "id": "pagelist"
    }
  }, _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "list-group-item",
      class: {
        active: _vm.currentPage.index === page.index
      },
      on: {
        "click": function($event) {
          return _vm.showPage(page)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(page.title) + "\n                        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer mt-2"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPage
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Folie hinzufügen\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteCurrentPage
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Folie löschen\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "min-height": "60vh"
    }
  }, [_c('form', {
    attrs: {
      "id": "pageForm"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage.title),
      expression: "currentPage.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentPage.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentPage, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bild")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 20%",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "2px",
      "border": "1px solid black"
    }
  }, [(_vm.currentPage.url != null) ? _c('img', {
    staticStyle: {
      "display": "inline-block",
      "max-width": "100%",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.currentPage.url,
      "alt": ""
    },
    on: {
      "click": _vm.uploadImage
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("\n                                Neues Bild hochladen\n                            ")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Folien")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Typ")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "pagetype",
      "disabled": ""
    }
  }, [_c('option', [_vm._v("Inhaltsseite")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-111e069c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Editor.vue
// module id = 115
// module chunks = 0